<template>
    <v-app>
        <v-layout align-center justify-center row fill-height class="notFoundWrap">
            <div class="imgWrap">
                <img src="../assets/images/notfound404.png" class="notFoundImg"/>
                <br/>
                <br/>
                <v-btn color="primary" depressed large @click="goPage('/dashboard')">홈으로 돌아가기</v-btn>
            </div>
        </v-layout>
    </v-app>
</template>

<script>
export default {
    name: 'notFound',
    methods: {
        goPage( pageName ) {
            this.$router.push( pageName )
        },
    }
}
</script>
<style lang="scss">
    @import '../assets/styles/index.scss';

    .notFoundWrap {
        position: relative;
        height: 100vh;
        width: 100%;
        text-align: center;
        background-color: #fff9ff;
    }
    .notFound { display: flex; justify-content: center; align-items: center; }
    .notFound .imgWrap { max-width: 50%; width: 30%; height: auto; }

    .notFoundImg {
        position:relative;top:0;left:0;
        width: 400px;margin:0 auto;
    }
</style>
